//Do not format this file with Prettier as it will break the logic
import { IActivity } from "../../shared/interfaces";
import moment from "moment";
const currentDate = new Date();

export const activityComparator = (a: IActivity, b: IActivity) => {
  if (a.status === "complete" && b.status === "complete") {
    if (a.completedOn && b.completedOn) {
      const aCompletedDate = new Date(a.completedOn).getTime();
      const bCompletedDate = new Date(b.completedOn).getTime();
      return bCompletedDate - aCompletedDate; 
    }
    return 0;
  }
  if (a.status === b.status) {
    if (a.type === "routine" && a.frequency && b.frequency) {
      // Sort by frequency
      if (a.frequency < b.frequency) {
        return 1;
      }
      if (a.frequency > b.frequency) {
        return -1;
      }
      return 0;
    }
    // Logic for "completionType" soon/sometime and updatedAt-based sorting
    else if (
      a.type === "task" &&
      a.createdAt &&
      b.createdAt &&
      a.completionType &&
      b.completionType &&
      ((a.completionType === "sometime" && b.completionType === "sometime") ||
        (a.completionType === "soon" && b.completionType === "soon"))
    ) {
      const aPriority = a.goal && a.goal.isPriority ? a.goal.isPriority : 0;
      const bPriority = b.goal && b.goal.isPriority ? b.goal.isPriority : 0;
      const aUpdatedAt = new Date(a.createdAt);
      const bUpdatedAt = new Date(b.createdAt);

      if (aPriority !== bPriority) {
        return bPriority - aPriority; // Priority tasks first
      }

      // Most recently updated comes first for both priority and non-priority
      return bUpdatedAt.getTime() - aUpdatedAt.getTime();
    } else if (a.type === "task" && a.completionDate && b.completionDate) {
      const aPriority = a.goal && a.goal.isPriority ? a.goal.isPriority : 0;
      const bPriority = b.goal && b.goal.isPriority ? b.goal.isPriority : 0;
    
      const parseDate = (date: string) =>
        new Date(date.length > 10 ? moment(date).format("YYYY-MM-DD") : date);
    
      const aDate = parseDate(a.completionDate);
      const bDate = parseDate(b.completionDate);
    
      const isAOverdue = aDate < currentDate;
      const isBOverdue = bDate < currentDate;
    
   
      if (isAOverdue && !isBOverdue) return -1;
      if (!isAOverdue && isBOverdue) return 1;
    
     
      const timeA = aDate.getTime();
      const timeB = bDate.getTime();
    
      if (timeA !== timeB) {
        return timeA - timeB; 
      }
    
     
      return bPriority - aPriority;
    }
  }

  // Sort by status - push completed activities to the bottom
  return a.status === "incomplete" ? -1 : 1;
};
